/**
 * Why this person can look but not change anything here: the business has no plan since its trial
 * ended, or their role reads only. Says the real reason (QA-0020) and is visible on the pages where
 * the missing buttons would otherwise just look like a bug (QA-0025).
 */
import { Eye } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useWorkspace } from "@/lib/session/workspace-context";
import { cn } from "@/lib/utils/cn";

export function ReadOnlyNotice({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { canWrite, plan, role } = useWorkspace();
  if (canWrite || !role) return null;
  const planEnded = plan?.kind === "expired";

  return (
    <p
      role="note"
      className={cn("flex items-start gap-2 text-sm text-muted-foreground", className)}
      data-testid="read-only-notice"
    >
      <Eye className="mt-0.5 size-4 shrink-0" />
      <span>
        {planEnded ? t("readOnly.plan") : t("readOnly.role", { role: t(`roles.${role}`) })}
        {planEnded && role === "owner" && (
          <>
            {" "}
            <Link
              to="/settings?tab=plan"
              className="font-medium text-primary underline decoration-primary/30 underline-offset-2 hover:decoration-primary"
            >
              {t("planBanner.choose")}
            </Link>
          </>
        )}
      </span>
    </p>
  );
}
